import React from "react";

const TyC = () => {
  return (
    <div className="bg-[#05141F] text-white p-6 pt-[40px] md:pt-[60px] min-h-screen">
      <h3 className="text-center text-2xl font-bold mt-[6rem] mb-6">
        Términos, Bases y Condiciones
      </h3>

      <section className="mb-8">
        <h4 className="text-lg font-semibold mb-2">
          SELTOS – Tasa Fija % | Hasta $17.000.000 | En 18 meses
        </h4>
        <p className="text-sm mb-2">
          Disponible para cartera de consumo. Válido para las operaciones
          solicitadas en el día de hoy en todo el territorio de la República
          Argentina. Stock 25 préstamos. Otorgamiento sujeto a condiciones de
          contratación y evaluación crediticia. Las tasas informadas son a
          título meramente orientativo, pudiendo variar en función del monto y
          plazo de la operación, de la política de crédito de Santander y del
          comportamiento crediticio del solicitante. Las tasas aplicables en
          cada caso serán informadas al momento de solicitar el préstamo y
          antes de su otorgamiento. Costo financiero total efectivo anual:
        </p>
        <p className="text-2xl font-bold mb-2">CFTEA 35,59%</p>
        <p className="text-xs mb-2">
          (Incluye seguro para un KIA SELTOS 0km terceros completo en CABA)
          tasa fija nominal anual: 0,00%. Tasa efectiva nominal anual: 0,00%.
          Sistema de amortización francés. Monto mínimo: $4.000.000, monto
          máximo: $17.000.000. Plazo mínimo: 12 meses, plazo máximo: 18 meses.
          Ejemplo: para una financiación de $10.000.000 otorgada en CABA por
          18 meses y TNA del 0,00%, la primera cuota será de $555.561,70 más
          $145.347,65 de seguro automotor. Monto máximo aplicable a todos los
          concesionarios KIA del país exceptuando a Tierra del Fuego. Gastos
          por cancelación del préstamo a cargo del cliente.
          <span className="italic">
            {" "}
            Para más información y condiciones aplicables, consulte en{" "}
            <a
              href="https://www.santander.com.ar"
              className="underline text-blue-400"
              target="_blank"
              rel="noopener noreferrer">
              www.santander.com.ar
            </a>
            .
          </span>
        </p>
      </section>

      <hr className="border-gray-600 my-10" />

      <section className="mb-8">
        <h4 className="text-lg font-semibold mb-2">
          K2500 AA - Tasa MiPyME 0% | Hasta $17.000.000 | En 18 meses
        </h4>
        <p className="text-sm mb-2">
          Disponible para cartera de consumo. Aplica a clientes personas
          físicas y jurídicas con condición MiPyME. Válido para las
          operaciones solicitadas en el día de hoy en todo el territorio de la
          República Argentina. Stock 30 préstamos. Otorgamiento sujeto a
          condiciones de contratación y evaluación crediticia. Las tasas
          informadas son a título meramente orientativo, pudiendo variar en
          función del monto y plazo de la operación, de la política de
          crédito de Santander y del comportamiento crediticio del
          solicitante. Las tasas aplicables en cada caso serán informadas al
          momento de solicitar el préstamo y antes de su otorgamiento. Costo
          financiero total efectivo anual:
        </p>
        <p className="text-2xl font-bold mb-2">CFTEA 35,59%</p>
        <p className="text-xs mb-2">
          (Incluye seguro para un KIA K2500 AA 0km terceros completo en CABA)
          tasa fija nominal anual: 0,00%. Tasa efectiva nominal anual: 0,00%.
          Sistema de amortización francés. Monto mínimo: $4.000.000, monto
          máximo: $17.000.000. Plazo mínimo: 12 meses, plazo máximo: 18 meses.
          A solicitud del cliente únicamente la primera cuota del préstamo
          podría abonarse a los 90 días de liquidado, el resto de las cuotas
          serán pagaderas mensualmente y en su fecha de pago original.
          Ejemplo: para una financiación de $10.000.000 otorgada en CABA por
          18 meses y TNA del 0,00%, la primera cuota será de $555.561,70 más
          $145.347,65 de seguro automotor. No incluye impuestos. Monto máximo
          aplicable a todos los concesionarios KIA del país exceptuando a
          Tierra del Fuego. Gastos por cancelación del préstamo a cargo del
          cliente.
          <span className="italic">
            {" "}
            Para más información y condiciones aplicables, consulte en{" "}
            <a
              href="https://www.santander.com.ar"
              className="underline text-blue-400"
              target="_blank"
              rel="noopener noreferrer">
              www.santander.com.ar
            </a>
            .
          </span>
        </p>
      </section>

      <hr className="border-gray-600 my-10" />

      <section>
        <h4 className="text-lg font-semibold mb-2">
          TASMAN – Tasa MiPyME 0% | Hasta $27.000.000 | En 18 meses
        </h4>
        <p className="text-sm mb-2">
          Disponible para cartera de consumo. Aplica a clientes personas
          físicas y jurídicas con condición MiPyME. Válido para las
          operaciones solicitadas en el día de hoy en todo el territorio de la
          República Argentina. Stock 25 préstamos. Otorgamiento sujeto a
          condiciones de contratación y evaluación crediticia. Las tasas
          informadas son a título meramente orientativo, pudiendo variar en
          función del monto y plazo de la operación, de la política de
          crédito de Santander y del comportamiento crediticio del
          solicitante. Las tasas aplicables en cada caso serán informadas al
          momento de solicitar el préstamo y antes de su otorgamiento. Costo
          financiero total efectivo anual:
        </p>
        <p className="text-2xl font-bold mb-2">CFTEA 35,59%</p>
        <p className="text-xs mb-2">
          (Incluye seguro para un KIA Tasman 0km terceros completo en CABA)
          tasa fija nominal anual: 0,00%. Tasa efectiva nominal anual: 0,00%.
          Sistema de amortización francés. Monto mínimo: $4.000.000, monto
          máximo: $27.000.000. Plazo mínimo: 12 meses, plazo máximo: 18 meses.
          Ejemplo: para una financiación de $10.000.000 otorgada en CABA por
          18 meses y TNA del 0,00%, la primera cuota será de $555.561,70 más
          $145.347,65 de seguro automotor. Monto máximo aplicable a todos los
          concesionarios KIA del país exceptuando a Tierra del Fuego. Gastos
          por cancelación del préstamo a cargo del cliente.
          <span className="italic">
            {" "}
            Para más información y condiciones aplicables, consulte en{" "}
            <a
              href="https://www.santander.com.ar"
              className="underline text-blue-400"
              target="_blank"
              rel="noopener noreferrer">
              www.santander.com.ar
            </a>
            .
          </span>
        </p>
      </section>
    </div>
  );
};

export default TyC;
